import { NODE_TYPES } from 'modules/workflows/constants';

export const notePrefix = 'note';
export const parseBackendNoteId = (id: number | string): string => `${notePrefix}${id}`;
export const NOTE_NODE_TYPE = NODE_TYPES.NOTE;

export const noteUtils = {
  parseBackendNoteId,
  type: NOTE_NODE_TYPE,
  prefix: notePrefix,
};

export default noteUtils;
